/** @jsx jsx */
import { useEffect } from 'react';
import { css, jsx } from '@emotion/react'
import { graphql } from 'gatsby';
import { useLocalization } from "gatsby-theme-i18n";
import PageHeadline from '../components/PageHeadline';
import CrosssiteBannerSection from '../sections/common/CrosssiteBannerSection';
import Seo from "../components/SEO"
import { parseHTML } from "../functions/common";
import CommonSection,{
  SectionFullWidthColumn,
  MarkdownContainer
} from "../components/CommonSection";



const LicensePage = ({data}) => {
  const { t, addString, localeKey } = useLocalization();

  useEffect(() => {
    addString('license',data.allLicenseCsv.nodes)
  },[addString,data]);

  return(<div css={css`background:#F7F7FA;`}>
    <Seo 
        title={data.pageTitle[localeKey]} 
        description={data.pageDescription[localeKey]}  />  
    <PageHeadline title={t('license.page.title')}/>
    <CommonSection>
      <SectionFullWidthColumn>
        <MarkdownContainer>
          {parseHTML(data.licenseText.childMarkdownRemark.html)}
        </MarkdownContainer>
      </SectionFullWidthColumn>
    </CommonSection>
    
    <CrosssiteBannerSection />
  </div>);
};

export default LicensePage;


export const query = graphql`
  query LicensePageQuery {
    pageTitle : licenseCsv(key: {regex: "/^page.title/"}) {
      ...localizedContent
    }
    pageDescription :licenseCsv(key: {regex: "/^page.description/"}) {
      ...localizedContent
    }
    pageKeywords : licenseCsv(key: {regex: "/^page.keywords/"}) {
      ...localizedContent
    }

    allLicenseCsv {
      nodes {
        ...localizedContent
      }
    }
    licenseText : file(sourceInstanceName: {eq: "markdown"}, relativePath: {eq: "software_license.md"}) {
      childMarkdownRemark {
        html
      }
    }
  }
`
